export default function PlaceCard({ place }) {
    return (
      <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow bg-white">
        <h2 className="text-xl font-semibold mb-2">
          {place.displayName?.text || 'Unnamed Place'}
        </h2>
        
        <div className="mb-3">
          <p className="text-gray-600 text-sm">
            {place.formattedAddress}
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2">
          {place.businessStatus && (
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
              {place.businessStatus}
            </span>
          )}
          
          {place.rating > 0 && (
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              {place.rating.toFixed(1)}
            </span>
          )}
          
          {place.priceLevel && (
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">
              {place.priceLevel.replace('PRICE_LEVEL_', '')}
            </span>
          )}
        </div>
        
        <div className="mt-4">
          <p className="text-sm text-gray-500">
            Coordinates: {place.location?.latitude?.toFixed(6)}, {place.location?.longitude?.toFixed(6)}
          </p>
        </div>
      </div>
    );
  }